import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT } from '../../styles/theme'

export const Card = styled.div<{ $isDragging: boolean }>`
  background: var(--color-bg-card);
  border: 1px solid
    ${({ $isDragging }) => ($isDragging ? 'var(--color-primary)' : 'var(--color-border)')};
  border-radius: ${BORDER_RADIUS.xl};
  padding: ${SPACING.lg};
  margin-bottom: ${SPACING.md};
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
  opacity: ${({ $isDragging }) => ($isDragging ? 0.45 : 1)};
  box-shadow: ${({ $isDragging }) => ($isDragging ? '0 8px 24px rgba(0,0,0,0.12)' : 'none')};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
`

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.sm};
`

export const DragHandle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  padding-top: 9px;
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: var(--color-text-tertiary);
  cursor: grab;
  touch-action: none;
  transition: color 0.15s ease;

  &:hover {
    color: var(--color-text-secondary);
  }

  &:active {
    cursor: grabbing;
  }
`

export const IndexBadge = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-tertiary);
  min-width: 18px;
  padding-top: 10px;
  flex-shrink: 0;
  text-align: right;
`

export const QuestionTextArea = styled.textarea`
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--color-border);
  border-radius: 0;
  padding: ${SPACING.xs} 0;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-family: inherit;
  color: var(--color-text-primary);
  line-height: 1.5;
  resize: none;
  overflow: hidden;
  min-height: 36px;
  outline: none;
  width: 100%;
  transition: border-color 0.15s ease;

  &:focus {
    border-bottom-color: var(--color-primary);
  }

  &::placeholder {
    color: var(--color-text-disabled);
  }
`

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--color-text-tertiary);
  cursor: pointer;
  border-radius: ${BORDER_RADIUS.md};
  padding: 0;
  flex-shrink: 0;
  margin-top: 4px;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover {
    color: #ef4444;
    background: rgba(239, 68, 68, 0.08);
  }
`
